import PageLayout from '@/pages/layout/PageLayout'
import NoticeList from "@/pages/notice/NoticeList"
import NoticeInfo from "@/pages/notice/NoticeInfo"
import NoticeCreate from "@/pages/notice/NoticeCreate"
import NoticeEdit from "@/pages/notice/NoticeEdit"
import CheckAuth from '@/pages/components/AuthCheck'
import { AUTH_GROUP } from '../../constants/constants'

const children = [{
  path: '/notice/list',
  name: 'NoticeList',
  component: NoticeList
}, {
  path: '/notice/info',
  name: 'NoticeInfo',
  component: NoticeInfo
}, {
  path: '/notice/create',
  name: 'NoticeCreate',
  component: CheckAuth(NoticeCreate, [AUTH_GROUP.BespinAdmin], '/customer/list')
}, {
  path: '/notice/edit',
  name: 'NoticeEdit',
  component: CheckAuth(NoticeEdit, [AUTH_GROUP.BespinAdmin], '/customer/list')
}]

export default [{
  path: '/',
  component: PageLayout,
  children
}]



// WEBPACK FOOTER //
// ./src/router/children/notice.js